import CalculatingAwardPage from "./CalculatingAwardPage"

export default CalculatingAwardPage
